/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HirePermissionsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Update one or more permissions from Hire
   * Update one or more permissions from Hire - temporary route, should be removed as soon as we are done with the migrations. The expectation for the permission key is to be either platform#hire_access or platform#hire_go_access
   * @param requestBody
   * @returns any Permissions updated successfully
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesPermissionsHire(
    requestBody: Array<{
      permissionKey: 'platform#hire_access' | 'platform#hire_go_access';
      permissionValue: boolean;
      roleUuid: string;
    }>,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/permissions/hire/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
